import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Architecture Struggles',
                topics: [
                    'The concept behind Cross-Cutting Concerns & how the usage of cross-cutting components impacts speed in the development and deployment process',
                    'Architectural decisions & styles at the right time when building distributed system',
                    `How can observability be modernized, improved, and scaled in today's services and platforms?`,
                ],
            },
            {
                title: 'Automation at Scale',
                topics: [
                    'Ways to leverage AI in the DevOps cycle (from code to production)',
                    'How to give value in agile teams with automation testing, agile methodologies',
                    'Management of deployments to a large amount of Azure Environments using DevOps',
                    'Infrastructure management and automation using CI/CD pipelines',
                ],
            },
            {
                title: 'DevOps Profession Guide',
                topics: [
                    'How to create insight & outside metrics to measure developer experience, build a sustainable engineering culture',
                    'The analysis of faster deployment to production based on Hypothesis-Driven Deployment',
                    'How to become a good contributor in agile world & enable IC growth in the organization',
                ],
            },
            {
                title: 'Tools to Boost DevOps Performance',
                topics: [
                    'How to use OpenTelemetry to troubleshoot and monitor production applications',
                    'Introduction to Media Streaming Mesh',
                    'How to extend any command on Linux easily',
                ],
            },
            {
                title: 'Kubernetes',
                topics: [
                    'Building and managing long-running processes in distributed systems (Kubernetes-as-a-Service) with high SLA numbers',
                    'Inssigts on Kubernetes, Java, Quarkus, Security',
                ],
            },
            {
                title: 'Up & Up to the Cloud',
                topics: [
                    'How to scale the operations in the cloud',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;